import {
  SCRAPER_REQUEST_PARAM,
  ScrapingParamInputFieldConfig,
} from '@decodo/utils';

import { SvgIcon } from '@/components/SvgIcon';

import iconLinkSrc from '~/svg/IconLink.svg';
import iconTargetSrc from '~/svg/IconTarget.svg';

type Props = {
  param: ScrapingParamInputFieldConfig;
};

const ScrapeTargetParamIcon = ({ param }: Props) => {
  if (param.key === SCRAPER_REQUEST_PARAM.QUERY) {
    return <SvgIcon src={iconTargetSrc} />;
  } else if (param.key === SCRAPER_REQUEST_PARAM.URL) {
    return <SvgIcon src={iconLinkSrc} />;
  }

  return null;
};

export default ScrapeTargetParamIcon;
